// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Dashboard.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { propTypes as ObservablePropTypes } from 'mobx-react';
import connect from 'share/enhancers/Izenda.Connect';
import uiState from 'logic/Izenda.UiState';
import { observe } from 'mobx';
import DashboardLeftNavigation from './LeftNavigation/Izenda.DashboardLeftNavigation';
import SettingsLevel from 'modules/Settings/SettingsLevel/Izenda.SettingsLevel';
import MainContent from 'share/components/layout/Izenda.MainContent';
import MainWrapper from 'share/components/layout/Izenda.MainWrapper';
import SettingsStore from 'logic/Izenda.SettingsStore';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import { isNil } from 'lodash/fp';
import AuthorizationConstants from 'logic/data/Izenda.AuthorizationConstants';
import Config from 'Izenda.Config';
@connect()
export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.settingStore = new SettingsStore(true);
    this.checkPermissionEntryDashboard();
  }

  static propTypes = {
    store: ObservablePropTypes.observableObject.isRequired,
    id: PropTypes.string,
    newDashboard: PropTypes.bool.isRequired
  };

  /**
   * Disable system level on dashboard viewer mode
   */
  updateSystemSetting() {
    if (!isNil(this.props.id) || this.props.newDashboard) {
      uiState.updateDisableSystemSetting();
    } else {
      uiState.enableSystemSetting();
    }
  }

  componentDidMount() {
    const props = this.props;

    // observe changing tenantId, then reload data for Dashboard
    this.disposeObserveTenantId = observe(uiState, 'tenantId', () => {
      if (uiState.silentUpdate) return;
      // when changing tenant, if dashboard is new --> cancel all changes
      // (only remaining selected preset) otherwise redirect to dashboard list.
      if (props.newDashboard) {
        props.store.cancelDashboard();
      } else {
        props.router.push({
          pathname: routeUtils.getDashboardUrl()
        });
      }
    });

    this.updateSystemSetting();
  }

  componentDidUpdate() {
    this.updateSystemSetting();
  }

  componentWillUnmount() {
    this.disposeObserveTenantId();
    this.settingStore.destroy();
  }

  /**
   * Check permission entry dashboard page
   */
  checkPermissionEntryDashboard = (): void => {
    const { props: { id, newDashboard, authorization, router } } = this;
    const isDashboardList = isNil(id) && !newDashboard;
    if (!isDashboardList) {
      const hasAddNewPrivileges = authorization.checkPrivileges([
        AuthorizationConstants.PERMISSION_KEY.DashboardsCanCreateNewDashboardValue
      ]);
      if (newDashboard && !hasAddNewPrivileges) {
        router.push(routeUtils.getNoPermissionUrl());
      }
    }
  };

  render() {
    const props = this.props;
    const { id, store, newDashboard, children } = props;

    // Only show dashboard left navigate for dashboard list and disable setting lvl
    const showDashboardLeftNavigate = isNil(id) && !newDashboard;

    return (
      <section className="izenda-TableLayout izenda-Dashboard">
        <SettingsLevel store={this.settingStore} />

        <MainWrapper settingStore={this.settingStore}>
          <div className="izenda-TableLayout u_paddingTopBottom">
            {showDashboardLeftNavigate && <DashboardLeftNavigation store={store} />}
            <MainContent>
              {children &&
                React.cloneElement(children, {
                  id,
                  store,
                  newDashboard
                })}
            </MainContent>
          </div>
        </MainWrapper>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/Izenda.Dashboard.js